import React from 'react';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-colors">
      <main>
        {children}
      </main>
    </div>
  );
};

export default Layout;
